module.exports = __webpack_public_path__ + "9f2c11da1d749ae2b85e9c381ef9ff52.svg";